module.exports = __webpack_public_path__ + "img/plasma-refining.3605be1b.png";